<template>
  <div :is="rootTag" v-bind="rootProps">
    <span
      class="text icon-message"
      :style="computedIconColors"
      @click="action"
      v-html="displayText"
    >
    </span>
    <slot name="close"></slot>
  </div>
</template>

<script>
import { Cdp } from 'src/apis'
import { useUserStore } from 'Store/user'
import { useIconMessageStore } from 'Store/icon-message'
import { useChatStore } from 'Store/chat'
import { lineBreaks } from 'Utilities'

export default {
  props: {
    index: { type: Number, required: true },
    message: { type: Object, required: true },
    openChat: { type: Function, required: true }
  },

  data() {
    return {
      userStore: useUserStore(),
      iconMessageStore: useIconMessageStore(),
      chatStore: useChatStore()
    }
  },

  computed: {
    displayText() {
      return lineBreaks(this.message.text)
    },

    userId() {
      return this.userStore.id
    },

    rootTag() {
      return this.message.url ? 'a' : 'div'
    },

    rootProps() {
      if (!this.message.url) return {}

      return {
        href: this.message.url,
        target: '_blank'
      }
    },

    computedIconColors() {
      return {
        backgroundColor: this.message.backgroundColor,
        color: this.message.textColor
      }
    }
  },
  methods: {
    action() {
      this.$gtag.recordIconMessageClicked(this.message)
      if (this.message.url) {
        this.trackMetrics('click')
        return
      }
      this.iconMessageStore.setSendImageMessage(this.message.id)
      this.openChat()
      this.trackMetrics('click')
    },

    trackMetrics(action) {
      if (!this.message.segment_ids || !this.message.segment_ids.length) return

      const metrics = this.message.segment_ids.map((id) => {
        const metric = {
          action,
          target_type: this.message.type,
          target_id: this.message.id,
          segment_id: id,
          user_id: this.userId
        }

        if (['icon_message', 'icon_image'].includes(this.message.type) && this.message.url) {
          metric.url = this.message.url
        } else if (this.message.type === 'icon_action' && this.message.buttons[0].url) {
          metric.url = this.message.buttons[0].url
        }

        return metric
      })

      Cdp.createMetrics(metrics)
    }
  }
}
</script>
